import { z } from 'zod';

const storageKey = 'vision-lab:mcp-authorization';
const intentSchema = z
  .object({
    request: z.string().regex(/^[0-9a-f]{64}$/),
    expires: z.number().finite(),
  })
  .strict();

/** Remember only a bounded local destination while the normal login flow completes. */
export function rememberMcpAuthorization(request: string) {
  sessionStorage.setItem(storageKey, JSON.stringify({ request, expires: Date.now() + 600_000 }));
}

export function readMcpAuthorization(): string | null {
  const raw = sessionStorage.getItem(storageKey);
  if (!raw) return null;
  try {
    const intent = intentSchema.parse(JSON.parse(raw));
    return intent.expires > Date.now() ? intent.request : null;
  } catch {
    return null;
  }
}

export function clearMcpAuthorization() {
  sessionStorage.removeItem(storageKey);
}
